import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-core-value',
  templateUrl: './core-value.component.html',
  styleUrls: ['./core-value.component.scss']
})
export class CoreValueComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
